import { Languages } from '../interfaces/common'
import { IUzGetPageRenderResponseTextParam } from '../utils/getCurrentTitle'

interface IGetPageRenderResponseTextParam {
  [Languages.RU]: string
  [Languages.KZ]: string
  [Languages.UZ]: string | IUzGetPageRenderResponseTextParam
}

export const MAIN_PAGE_TITLE: IGetPageRenderResponseTextParam = {
  [Languages.RU]: 'Обо мне. Личный кабинет - Актион-Медиа',
  [Languages.KZ]: 'Обо мне',
  [Languages.UZ]: {
    [Languages.UZ]: 'Men haqimda',
    [Languages.RU]: 'Обо мне',
  },
}
